import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { Redirect } from "react-router-dom";
import { Route } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
// import { Spinner } from "react-bootstrap";
import "./adminroute.css";

//private route provider component
const AdminRoute = ({ children, component, ...rest }) => {
  const { user, admin, adminLoading } = useAuth();
  if (user.email) {
  } else if (adminLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100vw",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Route
      {...rest}
      render={({ location }) =>
        user.email && admin.email ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: user.email ? "/userDashboard" : "/login",
              state: { from: location },
            }}
          ></Redirect>
        )
      }
    ></Route>
  );
};

export default AdminRoute;
